import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SpinnerService } from './services/spinner/spinner.service';
import { InfinityLoaderComponent } from './shared/infinity-loader/infinity-loader.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, InfinityLoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'company-manager';
  showSpinner: boolean = false;

  readonly _spinner = inject(SpinnerService);

  ngOnInit() {
    this._spinner.visibility.subscribe((value) => {
      Promise.resolve().then(() => (this.showSpinner = value));
    });
  }
}
